export default "__VITE_ASSET__Qihp7Y69__"